import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const bottomNavOffersSelector = createSelector(testTargetOffersSelector, offers => offers.bottomNavOffers || Empty.Object);

export { bottomNavOffersSelector };
